import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import asyncService from '../../../../../datahub/asyncService';
import theme from '../../../../../main-deprecated/theme';
import FormCloseButton from '../../../../components/Form/FormCloseButton';
import selectUser from '../../../../store/selectors/appSelector';

import HistoryCard from './HistoryCard';
import HistoryStepper from './HistoryStepper';
import TimecardHistoryHeader from './TimecardHistoryHeader';

const TimecardHistory = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [historyData, setHistoryData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { token, refreshToken } = useSelector(selectUser);
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    asyncService({
      httpMethod: 'POST',
      route: 'v2/timecards/history/read',
      data: { placementId: id },
      onSuccess: (results) => {
        setHistoryData(results?.data || []);
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
      dispatch,
      token,
      refreshToken,
    });
  }, [id, dispatch, token, refreshToken]);

  return (
    <Box padding={theme.spacing(4, 8, 8)}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <FormCloseButton onClose={() => navigate(-1)} message="buttonText.goBack" />
      </Box>

      {!isLoading ? (
        <>
          <TimecardHistoryHeader
            candidateName={historyData?.candidate?.name}
            placementName={historyData?.placement?.name}
            placementStart={historyData?.placement?.start}
            placementEnd={historyData?.placement?.end}
          />

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: '24px',
              flexDirection: 'column',
            }}
          >
            {historyData?.events?.map((event, index, arr) => (
              <Box key={event.date} display="flex">
                <HistoryStepper
                  eventType={event?.eventType}
                  index={index}
                  numOfEvents={arr.length}
                />
                <HistoryCard event={event} />
              </Box>
            ))}
          </Box>
        </>
      ) : (
        <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />
      )}
    </Box>
  );
};

export default TimecardHistory;
